import { Controller } from 'react-hook-form'

import Flex from '@/elements/Flex'
import Form from '@/elements/Form'
import FormInput from '@/elements/FormInput'
import FormSelect from '@/elements/FormSelect'
import FormFile from '@/elements/FormFile'
import type useIndividualInnerCircleForm from '@/hooks/forms/useIndividualInnerCircleForm'
import { statesData, type StateData } from '@/utils/stateData'

function IndividualInnerCircleForm(
  form: ReturnType<typeof useIndividualInnerCircleForm>['form']
) {
  return (
    <Form>
      <Controller
        name='avatar'
        control={form.control}
        render={({ field }) => (
          <FormFile
            {...field}
            files={field.value ? [field.value] : []}
            label='Profile Image'
            placeholder='Upload Photo'
            accept='.png, .jpg, .jpeg'
            onChange={e => {
              const file = e.target.files?.[0]
              field.onChange(file)
            }}
            onClear={() => {
              form.setValue('avatar', null)
              form.setValue('previousAvatar', '')
              field.onChange(null)
            }}
            error={form.formState.errors.avatar?.message}
            instructions='JPEG or PNG files supported.'
            preview='avatar'
            previousImageUrl={form.watch('previousAvatar') as string}
          />
        )}
      />
      <Flex className='form-group'>
        <Controller
          name='firstName'
          control={form.control}
          render={({ field }) => (
            <FormInput
              {...field}
              label='First Name'
              placeholder='Enter first name'
              error={form.formState.errors.firstName?.message}
              dirty={!!form.formState.dirtyFields.firstName}
            />
          )}
        />
        <Controller
          name='lastName'
          control={form.control}
          render={({ field }) => (
            <FormInput
              {...field}
              label='Last Name'
              placeholder='Enter last name'
              error={form.formState.errors.lastName?.message}
              dirty={!!form.formState.dirtyFields.lastName}
            />
          )}
        />
      </Flex>
      <Controller
        name='email'
        control={form.control}
        render={({ field }) => (
          <FormInput
            {...field}
            type='email'
            label='Email'
            placeholder='Enter email'
            dirty={!!form.formState.dirtyFields.email}
            error={form.formState.errors.email?.message}
          />
        )}
      />
      <Flex className='form-group'>
        <Controller
          name='city'
          control={form.control}
          render={({ field }) => (
            <FormInput
              {...field}
              label='City Location'
              placeholder='Enter city name'
              dirty={!!form.formState.dirtyFields.city}
              error={form.formState.errors.city?.message}
            />
          )}
        />
        <Controller
          name='state'
          control={form.control}
          render={({ field }) => (
            <FormSelect<StateData>
              {...field}
              label='State Location'
              placeholder='Select state'
              options={statesData}
              optionValue={item => item.state}
              optionLabel={item => `${item.state} (${item.stateCode})`}
              onChange={([val]) => field.onChange(val ? val.state : '')}
              values={
                field.value
                  ? statesData.filter(s => s.state === field.value)
                  : []
              }
              dirty={!!form.formState.dirtyFields.state}
              error={form.formState.errors.state?.message}
              filterBy={(item, search) =>
                item.state.toLowerCase().includes(search.toLowerCase()) ||
                item.stateCode.toLowerCase().includes(search.toLowerCase())
              }
            />
          )}
        />
      </Flex>
    </Form>
  )
}

export default IndividualInnerCircleForm
